import { SubscriptionDto } from "../../types/dto";
import { get, isMockMode, simulateDelay } from "../api";

export interface GetSubbedSubsReturnType {
	subscriberOrgId: string;
	totalAvailable: number;
	fetchedCount: number;
	skippedCount: number;
	results: Array<SubscriptionDto>;
}

export const getSubbedSubs = ({
	subscriberOrgId,
}: {
	subscriberOrgId: string;
}) => {
	if (isMockMode()) {
		const testData = {
			subscriberOrgId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
			totalAvailable: 5,
			fetchedCount: 5,
			skippedCount: 0,
			results: [
				{
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					name: "Test Name",
					issuerOrg: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
					},
					offering: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
						avatar: "data:image/png;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs=",
					},
					type: "Service",
					usedLicenceCount: 0,
					numberOfLicences: 10,
					expirationDateUtc: "2023-08-16T03:19:27.073",
					subscriptionManagers: [],
					isEnabled: true,
				},
				{
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					name: "Test Name",
					issuerOrg: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
					},
					offering: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
					},
					type: "Service",
					usedLicenceCount: 0,
					numberOfLicences: 10,
					expirationDateUtc: "2023-08-25T14:00:00",
					subscriptionManagers: [],
					isEnabled: true,
				},
				{
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					name: "Test Name",
					issuerOrg: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
					},
					offering: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
					},
					type: "Product_MachineLocked",
					usedLicenceCount: 4,
					numberOfLicences: 4,
					expirationDateUtc: "2050-09-08T14:00:00",
					subscriptionManagers: [],
					isEnabled: true,
				},
				{
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					name: "Test Name",
					issuerOrg: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
					},
					offering: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
					},
					type: "Service",
					usedLicenceCount: 0,
					numberOfLicences: 10,
					expirationDateUtc: "2022-10-07T14:00:00",
					subscriptionManagers: [],
					isEnabled: true,
				},
				{
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					name: "Test Name",
					issuerOrg: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
					},
					offering: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
					},
					type: "Service",
					usedLicenceCount: 0,
					numberOfLicences: 11,
					expirationDateUtc: "2023-09-15T14:00:00",
					subscriptionManagers: [],
					isEnabled: true,
				},
			],
		};

		return simulateDelay(
			50,
			() => testData
		) as Promise<GetSubbedSubsReturnType>;
	}

	return get(
		`Subscriptions/QuerySubscribedSubs?subscriberOrgId=${subscriberOrgId}`
	) as Promise<GetSubbedSubsReturnType>;
};
